<template>
	<section class="section quinielas-publicas">

		<!-- <h1 class="title">Quinielas Publicas</h1> -->
		<Panel title="Quinielas Públicas" icon="globe-americas">
			<div class="panel-block is-block" v-if="quinielas_publicas.length > 0">
				<div class="field">
					<p class="control has-icons-left" :class="{'is-loading' : false}">
						<input type="text" class="input is-small is-rounded" v-model="search" placeholder="Buscar...">
						<span class="icon is-small is-left">
							<font-awesome-icon icon="search" />
						</span>
					</p>
				</div>
			</div>
			<p class="panel-block" v-if="quinielas_publicas.length == 0">No hay quinielas públicas abiertas en este momento..</p>
			
			<router-link :to="'/ver-quiniela/' + quiniela.id" v-for="quiniela in quinielas_publicas_filtro" :key="quiniela.id+'-'+quiniela.jugadores_count" class="panel-block" style="display: block">
				<div class="level is-mobile">
					<div class="level-left">
						<div class="level-item nombre-quiniela" :class="{'disabled' : quiniela.status == 'terminada'}">
							<span class="truncate">{{ quiniela.nombre }}</span>
						</div>
					</div>
					<div class="level-right">
						<div class="level-item">

							<span :title="quiniela.jugadores_count + ' jugador(es)'" class="tag is-dark">
								<span class="icon"><font-awesome-icon icon="users" /></span>
								<span>{{ quiniela.jugadores_count }}</span>

								<span class="icon" :title="quiniela.apuesta + ' puntos para participar'" >
									<font-awesome-icon class="icon" icon="coins"/> 
								</span>
								<span>{{ quiniela.apuesta }}</span>
							</span>
						</div>
					</div>
				</div>
			</router-link>
		</Panel>
		
		<div v-if="quinielas_publicas.length == 0" style="margin-bottom: 1em;">
			<h2 class="title is-4">Haz una quiniela pública</h2>
			<h3 class="subtitle is-7">Crea una quiniela de Amigos que sea pública, los usuarios en Quinielazo podran verla y unirse a ella.</h3>
			<h3 class="subtitle is-7">Compartela con tus contactos utilizando los botones de compartir (<font-awesome-icon :icon="['fab','facebook-square']" /> <font-awesome-icon :icon="['fab','whatsapp']" />) mientras mas usuarios se unan, mayor el premio a ganar.</h3>
			
			<PartidosDisponibles />
			
		</div>
		
    	<Notificable texto="Notifícame cuando haya nuevos partidos o nuevas quinielas publicas" :mostrarConSubscripcion="false" />
	</section>
</template>

<script>
	import Panel from '@/components/Panel'
	import PartidosDisponibles from '@/components/PartidosDisponibles'
  import {mapState} from 'vuex'
  import Notificable from '@/components/Notificable'

	export default {
		components: { Panel,PartidosDisponibles, Notificable },
		name: 'QuinielasPublicas',

		data() {
			return {
				search: ''
			};
		},
		computed: {
			...mapState('quinielas',['quinielas_publicas']),
			quinielas_publicas_filtro(){
				return this.quinielas_publicas.filter(q => {
					return q.nombre.toLowerCase().includes(this.search.toLowerCase());
				});
			}
		},
		methods: {
		},
		created(){
			this.$store.dispatch('quinielas/fetchQuinielasPublicas')
		},
		metaInfo(){
			return {
				title: 'Quinielas Públicas | Quinielazo.com'
			}
		}
	};
</script>

<style lang="css" scoped>
.quinielas-publicas{
	padding: 1rem 1rem;
	min-height: 300px;
}
.quinielas-publicas article.message{
	margin-top: 1.5em;
}
</style>
